import { CustomLink } from '../../../PageElements/CustomLink';
import React from 'react';
import { TableHeading } from '../../../PageElements/TableHeading';
import style from './MarkdownTableOfContent.scss';
import { SIZES, Text, WEIGHTS } from '../../../PageElements/Text';
import gemoji from 'remark-gemoji';

const shouldAddChildToTableOfContent = (child) =>
  child.key.startsWith('section') && child.props.data.generatedFromHeading;

const isSectionFromH2 = (section) => section.props.data.headingLevel === 2;

const generateLinkComponentFromGeneratedSectionChild =
  (markdownPath) =>
  ({ props }) => {
    const { headingLevel, headingText } = props.data;
    const id = props.id;
    return (
      <li
        key={id}
        className={`${headingLevel === 3 ? style.h3Link : ''}`}
        data-hook={`toc-link-${id}`}
      >
        <CustomLink to={{ pathname: `/${markdownPath}`, hash: id }}>
          <gemoji>
            <Text
              size={SIZES.small}
              weight={WEIGHTS.normal}
              tagName="span"
              className={style.tocLinkText}
            >
              {headingLevel === 3 ? '\t\t' : ''}
              {headingText}
            </Text>
          </gemoji>
        </CustomLink>
      </li>
    );
  };

export const getLinkComponents = (children, markdownPath) => {
  const generatedSectionChildren =
    children && children.filter(shouldAddChildToTableOfContent);
  if (
    (generatedSectionChildren && generatedSectionChildren.length === 0) ||
    !generatedSectionChildren.some(isSectionFromH2)
  ) {
    return null;
  }

  return generatedSectionChildren.map(
    generateLinkComponentFromGeneratedSectionChild(markdownPath),
  );
};

export const generateTableOfContentFromMarkdown =
  ({ markdownPath }) =>
  ({ children }) => {
    const linkComponents = getLinkComponents(children, markdownPath);
    if (!(linkComponents && linkComponents.length)) {
      return null;
    }

    return (
      <div className={style.tocScrollContainer}>
        <div className={style.toc}>
          <TableHeading className={style.tocTitle}>
            In This Article
          </TableHeading>
          <ol id={`toc-${markdownPath}`}>{linkComponents}</ol>
        </div>
      </div>
    );
  };
